module.exports = [["INCLUDE","mask_passwords"],["KEEP","action:mmTime,mmUserLogged,mmPanic,mmMark,mmMarkStart,mmMarkStop,mmMarked,mmGps,mmH264,mmAlpr"]]